import {Component, OnInit} from '@angular/core';
import {MenuItem} from '../../model/MenuItem';
import {AuthService} from '../../service/auth.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  links: MenuItem[] = [
    {
      path: 'details',
      label: $localize`:Navigation|User profile title@@navigation-user-profile-title:Profile`
    }
  ];

  constructor(private authService: AuthService) {
  }

  async ngOnInit() {
    const session = await this.authService.getSession();
    if (session && (session.isTeacher() || session.isStudent())) {
      this.links.push({
        path: 'school',
        label: $localize`:Navigation|User school title@@navigation-user-school-title:School`
      });
    }
  }
}
